import { pgEnum } from 'drizzle-orm/pg-core'

/**
 * How the gear travels (spec §11 · I6).
 *
 * > Wybór w koszyku: odbiór osobisty (Wrocław 9 do 18) albo kurier InPost.
 *
 * Nothing in this schema modelled delivery at all before I6 — the site's own
 * copy said "nie wysyłamy kurierem", which spec §11 overturns. It decides two
 * things and both cost money: how many unpaid days the shelf loses either side
 * (`bufferMinutesFor`), and where the hire's clock starts.
 *
 * ── WHY IT HAS A FILE OF ITS OWN ─────────────────────────────────────────
 * Both `order` and `booking` carry it — the basket's choice and the copy that
 * governs each hire — and `bookings.ts` already imports `orders.ts`. Declared
 * in either of them, the other's import closes a cycle and drizzle-kit reads
 * the enum before it is initialised. It cannot live in `columns.ts` either:
 * the barrel deliberately does not re-export that file, so an enum hidden
 * there is an enum no migration ever creates.
 */
export const deliveryMethod = pgEnum('delivery_method', ['PICKUP', 'COURIER'])

export type DeliveryMethod = (typeof deliveryMethod.enumValues)[number]
